import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  TravelsCurrentStatus
} from '../../authentication/connection/interfaces/apiInterfaces';

export class GetTravelsCurrentStatusCommand extends IRequestCommand<
  IGetCarrierPreferenceResponse,
  ErrorDetails,
  IGetTravelCurrentStatusCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/travelsCurrentStatus/carrier/{carrierId}';
  public override setParameters(parameters: IGetTravelCurrentStatusCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierUserId.toString()
    );
  }
}

export interface IGetTravelCurrentStatusCommandParameters
  extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetCarrierPreferenceResponse
  extends ICommandResponse,
  TravelsCurrentStatus {}
